<section class="image-picker" aria-label="בחירת תמונות למודעה">
  <div class="image-picker-heading">
    <span class="heading-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24">
        <rect x="3" y="4" width="18" height="16" rx="3"></rect>
        <circle cx="8.5" cy="9" r="1.5"></circle>
        <path d="m5.5 17 4.2-4.2 3.1 3.1 2.1-2.1 3.6 3.2"></path>
      </svg>
    </span>
    <span>
      <strong>הוסיפו תמונות איכותיות</strong>
      <small>מומלץ לצלם באור טוב ומכמה זוויות</small>
    </span>
    <span class="image-limit">עד 5 תמונות</span>
  </div>

  <div class="image-grid">
    <div class="image-slot is-primary">
      <app-images-box (onChange)="onChange($event, 0)" [imageSelected]="slots[0]" [title]="'תמונה ראשית'"></app-images-box>
    </div>
    <div class="image-slot"><app-images-box (onChange)="onChange($event, 1)" [imageSelected]="slots[1]" [title]="'תמונה 1'"></app-images-box></div>
    <div class="image-slot"><app-images-box (onChange)="onChange($event, 2)" [imageSelected]="slots[2]" [title]="'תמונה 2'"></app-images-box></div>
    <div class="image-slot"><app-images-box (onChange)="onChange($event, 3)" [imageSelected]="slots[3]" [title]="'תמונה 3'"></app-images-box></div>
    <div class="image-slot"><app-images-box (onChange)="onChange($event, 4)" [imageSelected]="slots[4]" [title]="'תמונה 4'"></app-images-box></div>
  </div>
</section>
